import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';
import { miradorThemeProdem } from './mirador-theme/miradorThemeProdem';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Carta',
  type: 'carta',
  bodyClasses: 'mr-custom-carta',
  sections: {
    top: [
      {
        id: 'image-viewer-iiif',
        type: 'viewer-iiif',
        title: 'resource#image-viewer-iiif',
        options: {
          libOptions: {
            theme: miradorThemeProdem,
            window: {
              allowClose: false,
              allowMaximize: false,
              allowFullscreen: true,
              allowTopMenuButton: false,
              defaultSidebarPanelWidth: 450,
              highlightAllAnnotations: true,
              defaultSideBarPanel: 'annotations',
              sideBarOpen: true,
              views: [
                { key: 'single' },
                { key: 'gallery' },
              ],
            },
            workspaceControlPanel: {
              enabled: false,
            },
            id: 'mirador-container',
          },
        }
      },
       {
        id: 'header-carta',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      {
        id: 'collection-related',
        type: 'collection',
        grid: 1,
        title: 'Manoscritto collegato',
      },
      {
        id: 'metadata',
        type: 'metadata',
        title: 'resource#metadata',
      },
      {
        id: 'metadata-annotazioni',
        type: 'metadata',
        title: 'resource#metadata_annotazioni',
      },
    ],
  },
} as ConfigMurucaResourceLayout;
